var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrakeSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1629 0.00359495C21.5308 0.592131 27.4078 6.46916 27.9964 13.837C28.0462 14.461 27.5738 14.9781 26.9662 15.048V15.0564L26.8256 15.0561L25.8876 15.0564C25.8876 22.2048 20.0925 28 12.9438 28C5.79516 28 0 22.2048 0 15.0564C0 7.9076 5.79516 2.11244 12.9438 2.11244L12.9438 4.2697C18.901 4.2697 23.7303 9.09898 23.7303 15.0562L25.8876 15.0564C25.8876 7.9077 20.0925 2.11244 12.9438 2.11244V1.17442L12.9439 1.16072V1.03361H12.9518C13.0218 0.426019 13.5391 -0.0461195 14.1629 0.00359495ZM12.9439 20.4494C15.9224 20.4494 18.3371 18.0348 18.3371 15.0561L23.4489 15.0564C23.4489 20.8581 18.7456 25.5613 12.9438 25.5613C7.14199 25.5613 2.43869 20.8581 2.43869 15.0564C2.43869 9.25436 7.14199 4.55113 12.9438 4.55113L12.9439 9.66279C9.96523 9.66279 7.55058 12.0774 7.55058 15.0561C7.55058 18.0348 9.96523 20.4494 12.9439 20.4494Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakeSystem);
export default __webpack_public_path__ + "static/media/BrakeSystem.b3cf84ae1f9a1505e7967334ba4d3059.svg";
export { ForwardRef as ReactComponent };